import palette from 'theme/palette';

export default {
  colorPrimary: {
    color: '#fff',
    backgroundColor: palette.background.default,
  },
};
